import { useVideoPlayer } from "expo-video";
import { useEffect, useState } from "react";

export const useVideoControls = (uri: string, loop = false) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);

  const player = useVideoPlayer(uri, (player) => {
    player.loop = loop;
    player.muted = false;
    player.pause();
  });

  useEffect(() => {
    const interval = setInterval(() => {
      if (player.currentTime !== undefined) {
        setCurrentTime(player.currentTime);
      }

      if (player.duration !== undefined && player.duration > 0) {
        setDuration(player.duration);
      }
    }, 500);

    return () => clearInterval(interval);
  }, [player]);

  const togglePlay = () => {
    if (isPlaying) {
      player.pause();
    } else {
      player.play();
    }
    setIsPlaying((prev) => !prev);
  };

  const toggleMute = () => {
    player.muted = !isMuted;
    setIsMuted((prev) => !prev);
  };

  const seek = (ratio: number) => {
    if (duration > 0) {
      const newTime = ratio * duration;
      player.currentTime = newTime;
      setCurrentTime(newTime);
    }
  };

  const progress = duration > 0 ? currentTime / duration : 0;

  return {
    player,
    isPlaying,
    isMuted,
    currentTime,
    duration,
    progress,
    togglePlay,
    toggleMute,
    seek,
  };
};
